<template>
  <div>
    <canvas :id="labelName" class="m-auto mb-3" width="100" height="30"></canvas>
    <span v-if="showModuleLegends">
      <div
        class="row m-auto float-left source-sans-pro cursor-pointer"
        v-for="datum in data"
        :key="datum"
        @click="selectedModule(datum.labels[0])"
      >
        <div class="col-6">
          <p class="text-left mb-0 label-style">{{getName(datum.labels[0])}}</p>
        </div>
        <div class="col-auto">
          <div
            class="pl-1"
            :style="'background-color:'+datum.backgroundColor[0]+'; color: white; width: 100px'"
          >{{datum.data[0]}}%</div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: [
    "type",
    "labelName",
    "labels",
    "data",
    "colors",
    "borderColor",
    "showLegend",
    "showModuleLegends",
    "xAxesData"
  ],
  data() {
    return {
      chartData: {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: this.data
        },
        options: {
          responsive: true,
          legend: {
            display: this.showLegend,
            marginRight: 0,
            position: "left",
            usePointStyle: true,
            labels: { boxWidth: 30, defaultFontSize: 10, pointStyle: "circle" }
          },
          showAllTooltips: true,
          legendCallback: function(chart) {
            if (this.showModuleLegends) {
              var text = [];
              var legs = [];
              for (var j = 0; j < chart.data.datasets.length; j++) {
                for (var i = 0; i < chart.data.datasets[j].data.length; i++) {
                  var newd = {
                    label: chart.data.datasets[j].labels[i],
                    color: chart.data.datasets[j].backgroundColor[i]
                  };

                  if (!containsObject(newd, legs)) {
                    legs.push(newd);
                  }
                }
              }

              text.push('<ul class="Mylegend ' + chart.id + '-legend">');
              for (var k = 0; k < legs.length; k++) {
                text.push(
                  '<li><span style="background-color:' +
                    legs[k].color +
                    '"></span>'
                );
                text.push(legs[k].label);
                text.push("</li>");
              }
              text.push("</ul>");
              return text.join("");
            }
          },
          // legend: {
          //   display: false,
          // },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                var dataset = data.datasets[tooltipItem.datasetIndex];
                var index = tooltipItem.index;
                return dataset.labels[index] + ": " + dataset.data[index];
              }
            }
          },
          // }
          // lineTension: 1,
          scales: this.xAxesData
          // onClick: function(event, elem) {
          //   console.log(event);
          //   var elem = elem[0];
          //   if (!elem) return; // check and return if not clicked on bar/data
          //   // else...
          //   // just for test
          //   // modal opening code goes here...
          // }
        }
      }
    };
  },
  mounted() {
    console.log(this.labelName);
    this.createChart(this.labelName, this.chartData);
  },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      });
    },
    getName(name) {
      return name.split("(Completed)")[0];
    },
    selectedModule(moduleName) {
      let nameOfModule = moduleName.split("(Completed)")[0];
      this.$emit("getModuleCharts", nameOfModule);
    }
  }
};
</script>

<style>
.label-style {
  width: 120px;
  color: black;
  padding-left: 10px;
  padding-right: 10px;
  border: 1px solid #00000010;
}
</style>